export function splitStringOnTokens(input: string, partsSoFar: string[] = []): string[] {
	const tokenStartIndex = input.indexOf('{{');

	if (tokenStartIndex > -1) {
		const startOfString = input.slice(0, tokenStartIndex);
		const stringRemainder = input.replace(startOfString, '');
		const token = stringRemainder.slice(0, stringRemainder.indexOf('}}') + 2);
		const restOfString = stringRemainder.replace(token, '');

		return splitStringOnTokens(restOfString, [...partsSoFar, startOfString, token]);
	}

	return [...partsSoFar, input];
}

export function truncate(text: string, options: { length: number; omission: string }): string {
	const { length, omission } = options;
	if (text.length <= length) {
		return text;
	}
	return text.slice(0, length - omission.length) + omission;
}

export function truncateFilename(rawFileName: string, truncateLength: number = 25): string {
	const fileExtensionIndex = rawFileName.lastIndexOf('.');
	const fileName = rawFileName.slice(0, fileExtensionIndex);
	const extension = rawFileName.slice(fileExtensionIndex);

	return `${truncate(fileName, {
		length: truncateLength,
		omission: '[...]',
	})}${extension}`;
}

const keys = ['firstName', 'entryCode', 'friendlyPrizeName'];

export function interpolateTokens(contents: string, searchParams: URLSearchParams) {
	return keys.reduce((acc, key) => {
		return acc.replace(new RegExp(`\{\{\\s?${key}\\s?}}`, 'gi'), searchParams.get(key) || '');
	}, contents);
}

export function interpolateTokensFromObject(contents: string, tokens: Record<string, string>) {
	return keys.reduce((acc, key) => {
		return acc.replace(new RegExp(`\{\{\\s?${key}\\s?}}`, 'gi'), tokens[key]);
	}, contents);
}

export const interpolateTokensInElement = (element: HTMLElement, searchParams: URLSearchParams) => {
	const contents = element.innerText;
	const interpolatedContents = interpolateTokens(contents, searchParams);
	element.innerText = interpolatedContents;
};

export const stringifyUrlParameters = (obj: Record<string, any>) => {
	return Object.entries(obj)
		.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
		.join('&');
};
